import { useEffect } from 'react';

function Hero() {
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${window.BASE_URL}/api`);
        const data = await response.json();
        const landingNameElement = document.getElementById('landing-name');
        if (landingNameElement && data.title) {
          landingNameElement.textContent = data.title;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bg-primary text-white text-center d-flex align-items-center" style={{ minHeight: "90vh" }}>
      <div className="container">
        <h1 className="display-3 fw-bold">Sağlığınıza Değer Katıyoruz!. (<span id="landing-name"></span>)</h1>
        <p className="lead my-4">Profesyonel ekibimizle sizin için buradayız.</p>
        <a href="#contact" className="btn btn-light btn-lg">Hemen İletişime Geçin</a>
      </div>
    </div>
  );
}

export default Hero;